import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { identifyViblo, loadViblo } from '../../util/viblo';

/**
 * Loads Viblo (feedback button, optional session recording) once a member is
 * signed in, and tells it who they are. Visitors who aren't signed in never
 * load it. Sign-out resets it (see auth.duck logout).
 */
const VibloForMembers = () => {
  const currentUser = useSelector(state => state.user?.currentUser);
  const userId = currentUser?.id?.uuid;
  const key = process.env.REACT_APP_VIBLO_KEY;

  useEffect(() => {
    if (!key || !userId) {
      return;
    }
    loadViblo(key);
    identifyViblo(currentUser);
    // Re-identify only when the member changes, not on every profile update.
  }, [key, userId]);

  return null;
};

export default VibloForMembers;
